import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <g>
    <g stroke="null" id="Icon" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="null"
        fill="#F53636"
        d="m17.84293,16.16604l0.00827,-12.38077l2.36355,0l0,16.42946l-16.42951,0l0,-2.36355l12.38082,-0.0081l-12.38082,-12.38082l1.67697,-1.67698l12.38071,12.38077z"
        id="color-fix"
      />
    </g>
    <path
      stroke="null"
      d="m17.84293,16.16604l0.00827,-12.38077l2.36355,0l0,16.42946l-16.42951,0l0,-2.36355l12.38082,-0.0081l-12.38082,-12.38082l1.67697,-1.67698l12.38071,12.38077z"
      id="color-fix"
      xmlns="http://www.w3.org/2000/svg"
    />
  </g>,
  "Decrease"
);
